import React, { useState } from 'react'
import { Grid, InputAdornment, TextField } from '@mui/material'
import Button from '@mui/material/Button'
import SearchIcon from '@mui/icons-material/Search'
import FilterAltIcon from '@mui/icons-material/FilterAlt'

import PipelineFilterDrawer from './PipelineFilterDrawer'

export interface IFilterMapped {
  page?: number;
  perPage?: number;
  search?: string | null;
  startDate?: string;
  endDate?: string;
  displayType?: EPipelineDisplayType;
}

export enum EPipelineDisplayType {
  DELETE = 'delete',
  USED = 'used',
}

interface FilterProps {
  filter: IFilterMapped
  onFilterChange: (filter: IFilterMapped) => void;
  onSearch: (filter: IFilterMapped) => void;
}

const PipelineFilter = ({ onFilterChange, filter, onSearch }: FilterProps) => {
  const { search } = filter
  const [isOpenedFilterDrawer, setIsOpenedFilterDrawer] = useState<boolean>(false)

  return (
    <>
      <PipelineFilterDrawer
        isOpen={isOpenedFilterDrawer}
        onClose={() => setIsOpenedFilterDrawer(false)}
        onFilterChange={onFilterChange}
        filter={filter}
        onSearch={onSearch}
      />
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} lg={7}>
          <TextField
            InputProps={{
              startAdornment: (<InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>),
            }}
            label={'ค้นหา Pipeline'}
            fullWidth
            id="search"
            name="search"
            variant="filled"
            value={search || ''}
            onChange={(e) => onFilterChange({ ...filter, search: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} lg={2}>
          <Button
            color="inherit"
            size="large"
            fullWidth
            variant="contained"
            startIcon={<FilterAltIcon />}
            onClick={() => {
              setIsOpenedFilterDrawer(true)
            }}
            sx={{ height: '100%' }}
          >
            ค้นหาโดยละเอียด
          </Button>
        </Grid>
        <Grid item xs={12} lg={3}>
          <Button
            color="primary"
            size="large"
            fullWidth
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={() => onSearch(filter)}
            sx={{ height: '100%' }}
          >
            ค้นหา
          </Button>
        </Grid>
      </Grid>
    </>)
}

export default PipelineFilter
